<template>
  <div>
    <!--
    <b-button v-b-toggle.sidebar>Toggle Sidebar</b-button>
    -->
    <b-sidebar
      id="sidebar"
      title="Sidebar with backdrop"
      shadow
      class="bd-sidebar"
     
    >
      <div class="px-3 py-2">
        <b-form-group label="Backdrop variant" label-for="backdrop-variant">
          <b-form-select
            id="backdrop-variant"
            v-model="variant"
            :options="variants"
          ></b-form-select>
        </b-form-group>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      variant: "dark",
      variants: [
        "transparent",
        "white",
        "light",
        "dark",
        "primary",
        "secondary",
        "success",
        "danger",
        "warning",
        "info",
      ],
    };
  },
};
</script>